const assets = {
    LOGO : require('../assets/logo.png'),
    LOGO_WHITE : require('../assets/logo_white.png'),
    SUCCEED : require('../assets/succeed.png'),
    FAILED : require('../assets/failed.png'),
}

export default assets;
